import React from "react";
import { useOpenStatus } from "../hooks/useOpenStatus";

const shortDay = (d) => (d === "Today" || d === "Tomorrow" ? d : (d ? d.slice(0, 3) : ""));

// Live open/closed indicator (Atlanta time). Green pulse when open, red when closed.
export default function OpenStatusBadge({ className = "", bordered = true }) {
  const { isOpen, closesAt, reopenDay, reopenTime } = useOpenStatus();
  const text = isOpen
    ? `Open till ${closesAt}`
    : reopenDay
      ? `Closed · Opens ${shortDay(reopenDay)} ${reopenTime}`
      : "Closed";

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs ${
        bordered ? "border bg-nala-charcoal/60" : ""
      } ${isOpen ? "border-green-500/40" : "border-red-500/30"} ${className}`}
    >
      <span className="relative flex h-2 w-2">
        {isOpen && (
          <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping" />
        )}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${isOpen ? "bg-green-400" : "bg-red-500"}`} />
      </span>
      <span className={isOpen ? "text-green-300" : "text-red-300"}>{text}</span>
    </span>
  );
}
